export default __webpack_public_path__ + "static/media/ecoedilBack.a363c1e5.png";